import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconWidgetMail = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      className="block w-full h-full"
      fill="none"
      stroke="currentColor"
    >
      <path
        d="M5 13.334L18.151 22.1013C19.2707 22.8478 20.7293 22.8478 21.849 22.1013L35 13.334M8.33333 31.6673H31.6667C33.5076 31.6673 35 30.1749 35 28.334V11.6673C35 9.82637 33.5076 8.33398 31.6667 8.33398H8.33333C6.49238 8.33398 5 9.82637 5 11.6673V28.334C5 30.1749 6.49238 31.6673 8.33333 31.6673Z"
        stroke="#1A202C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  );

IconWidgetMail.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconWidgetMail;
